module.exports = __webpack_public_path__ + "media/images/ai_voice_samples/savannah-1fdd0b4e0893f48d1d9563d2f07430c7.mp3";